<div *ngIf="isSending" class="loader-overlay">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>

<!-- complaints.component.html -->
<div *ngIf="showPopup" class="complaints-backdrop">
  <div
    class="complaints-modal container"
    role="dialog"
    aria-modal="true"
    aria-labelledby="modal-headline"
  >
    <div class="complaints-content">
      <div class="complaints-header">
        <div class="complaints-icon">
          <span class="material-icons">feedback</span>
        </div>
        <h3 class="complaints-title" id="modal-headline">
          Customer Complaints
        </h3>
      </div>

      <div class="alert alert-info mb-4">
        <span class="material-icons me-2">info</span>
        <p>
          This is for complaints only. For general queries, please
          contact us via
          <a
            href="https://facebook.com/TeloneZW"
            target="_blank"
            class="text-link facebook"
            >Facebook</a
          >
          or
          <a
            href="https://x.com/TelOneZW"
            target="_blank"
            class="text-link twitter"
            >Twitter</a
          >.
        </p>
      </div>

      <div class="complaints-body">
        <form [formGroup]="complaintsForm" (ngSubmit)="onSubmit()">
          <div class="card mb-4">
            <div class="card-header bg-light">
              <h5 class="mb-0">Personal Information</h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label for="accountName" class="form-label"
                    >Account Name <span class="text-danger"></span
                  ></label>
                  <input
                    type="text"
                    class="form-control"
                    id="accountName"
                    formControlName="accountName"
                    placeholder="John Doe"
                    [ngClass]="{
                      'is-invalid':
                        complaintsForm.get('accountName')!.invalid &&
                        (complaintsForm.get('accountName')!.dirty ||
                          complaintsForm.get('accountName')!.touched)
                    }"
                  />
                  <div
                    class="invalid-feedback"
                    *ngIf="
                      complaintsForm.get('accountName')!.invalid &&
                      (complaintsForm.get('accountName')!.dirty ||
                        complaintsForm.get('accountName')!.touched)
                    "
                  >
                    Account name is required.
                  </div>
                </div>

                <div class="col-md-6 mb-3">
                  <label for="landlineNumber" class="form-label"
                    >Landline Number
                    <span class="optional">(Optional)</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="landlineNumber"
                    formControlName="landlineNumber"
                    placeholder="0242 123 123"
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 mb-3">
                  <label for="mobileNumber" class="form-label"
                    >Mobile Number <span class="text-danger"></span
                  ></label>
                  <input
                    type="text"
                    class="form-control"
                    id="mobileNumber"
                    formControlName="mobileNumber"
                    placeholder="+263 7xx xxx xxx"
                    [ngClass]="{
                      'is-invalid':
                        complaintsForm.get('mobileNumber')!.invalid &&
                        (complaintsForm.get('mobileNumber')!.dirty ||
                          complaintsForm.get('mobileNumber')!.touched)
                    }"
                  />
                  <div
                    class="invalid-feedback"
                    *ngIf="
                      complaintsForm.get('mobileNumber')!.invalid &&
                      (complaintsForm.get('mobileNumber')!.dirty ||
                        complaintsForm.get('mobileNumber')!.touched)
                    "
                  >
                    Mobile number is required.
                  </div>
                </div>

                <div class="col-md-6 mb-3">
                  <label for="email" class="form-label"
                    >Email Address <span class="text-danger"></span
                  ></label>
                  <input
                    type="email"
                    class="form-control"
                    id="email"
                    formControlName="email"
                    placeholder="johndoe@example.com"
                    [ngClass]="{
                      'is-invalid':
                        complaintsForm.get('email')!.invalid &&
                        (complaintsForm.get('email')!.dirty ||
                          complaintsForm.get('email')!.touched)
                    }"
                  />
                  <div
                    class="invalid-feedback"
                    *ngIf="
                      complaintsForm.get('email')!.invalid &&
                      (complaintsForm.get('email')!.dirty ||
                        complaintsForm.get('email')!.touched)
                    "
                  >
                    A valid email is required.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card mb-4">
            <div class="card-header bg-light">
              <h5 class="mb-0">Complaint Details</h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label for="region" class="form-label"
                    >Region
                    <span class="optional">(Optional)</span></label
                  >
                  <select
                    id="region"
                    class="form-select"
                    formControlName="region"
                    (change)="onRegionChange()"
                  >
                    <option value="" disabled selected>Select your region</option>
                    <option *ngFor="let region of regions" [ngValue]="region">
                      {{ region.LONG_NAME }}
                    </option>
                  </select>
                </div>

                <div class="col-md-6 mb-3" *ngIf="exchanges.length > 0">
                  <label for="exchange" class="form-label"
                    >Nearest Exchange
                    <span class="optional">(Optional)</span></label
                  >
                  <select
                    id="exchange"
                    class="form-select"
                    formControlName="exchange"
                  >
                    <option value="" disabled selected>Select nearest exchange</option>
                    <option *ngFor="let exchange of exchanges" [value]="exchange.LONG_NAME">
                      {{ exchange.LONG_NAME }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row">
                <div class="col-12 mb-3">
                  <label for="customerFeedback" class="form-label"
                    >Customer Feedback <span class="text-danger"></span
                  ></label>
                  <textarea
                    class="form-control"
                    id="customerFeedback"
                    formControlName="customerFeedback"
                    rows="6"
                    placeholder="Share your customer experience and any pain points you faced.."
                    [ngClass]="{
                      'is-invalid':
                        complaintsForm.get('customerFeedback')!.invalid &&
                        (complaintsForm.get('customerFeedback')!.dirty ||
                          complaintsForm.get('customerFeedback')!.touched)
                    }"
                  ></textarea>
                  <div
                    class="invalid-feedback"
                    *ngIf="
                      complaintsForm.get('customerFeedback')!.invalid &&
                      (complaintsForm.get('customerFeedback')!.dirty ||
                        complaintsForm.get('customerFeedback')!.touched)
                    "
                  >
                    Customer feedback is required.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- TODO: Add information about consent before submission, as a radio button -->
          <!-- Add this before the submit buttons in complaints.component.html -->
<div class="card mb-4">
  <div class="card-body">
    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        id="consentCheckbox"
        formControlName="consent"
        [ngClass]="{
          'is-invalid':
            complaintsForm.get('consent')!.invalid &&
            (complaintsForm.get('consent')!.dirty ||
              complaintsForm.get('consent')!.touched)
        }"
      />
      <label class="form-check-label" for="consentCheckbox">
        I consent to TelOne using my personal information to process this complaint and
        for quality improvement purposes. I understand that my information will be
        handled in accordance with TelOne's Privacy Policy.
      </label>
      <div
        class="invalid-feedback"
        *ngIf="
          complaintsForm.get('consent')!.invalid &&
          (complaintsForm.get('consent')!.dirty ||
            complaintsForm.get('consent')!.touched)
        "
      >
        You must agree to the consent terms to submit your complaint.
      </div>
    </div>
  </div>
</div>

          <div class="d-flex justify-content-end mt-4 gap-2">
            <button
              type="button"
              class="btn btn-secondary mx-3"
              (click)="onCancelClick()"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              [disabled]="complaintsForm.invalid"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<button (click)="onButtonClick()" *ngIf="!showPopup" class="btn complaints-btn">
  <div class="complaints-btn-icon me-2">
    <span class="material-icons">feedback</span>
  </div>
  <span>Report an Issue</span>
</button>
